import { loadStripe } from "@stripe/stripe-js/pure";

// Stripe.js loads only when something asks for it. Importing
// "@stripe/stripe-js" (not /pure) injects the script as a side effect of the
// import, which put it on every page of every shop, payments or not.
let platformStripePromise: ReturnType<typeof loadStripe> | null = null;

// Platform-level Stripe (no connected account). Shared so it loads once.
export const getPlatformStripePromise = () => {
  if (!platformStripePromise) {
    platformStripePromise = loadStripe(
      process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!
    );
  }
  return platformStripePromise;
};

export { loadStripe };
